export function createWebLogApi() {
  return {
    sendLog(level: string, message: string): void {
      const fn =
        level === 'error' ? console.error
        : level === 'warn' ? console.warn
        : console.log;
      fn(`[${level.toUpperCase()}]`, message);
    },
  };
}
